// extracted by mini-css-extract-plugin
export default {"controlButton":"WiTPiC","hidden":"sE31hn","timeWrapper":"KpdQrc","time":"gkGtxN","duration":"pkI6sF","liveMode":"LyvFhE","separator":"Nidhcc"};